import React, { useRef } from "react";
import Router from "@components/router.js";
import checkmark from "@images/checkmark.svg";
import { toast } from "react-toastify";

const Description = ({
  showDetails,
  activeTab,
  features,
  paidPro = false,
  paidStandartPlus = false,
}) => {
  const handleClick = () => {
    const onResponce = (res_data) => {
      if (res_data.success) {
        window.location.replace(res_data.message.url);
      } else {
        toast.error(res_data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          zIndex: 9999,
        });
      }
    };

    const tariff_level_key = paidPro
      ? "pro"
      : paidStandartPlus
      ? "standard_plus"
      : null;

    Router.fetchWithData(
      "/payments",
      { tariff_key: activeTab, tariff_level_key: tariff_level_key },
      "POST",
      onResponce
    );
  };

  const ulRef = useRef(null);
  let styleDescription = {};
  if (showDetails) {
    styleDescription = {
      paddingTop: "22px",
      paddingBottom: "24px",
      height: ulRef?.current?.offsetHeight || 0,
    };
  } else {
    styleDescription = {
      paddingTop: 0,
      paddingBottom: 0,
      height: 0,
    };
  }

  return (
    <div className="description" style={styleDescription}>
      <div className="description-block" ref={ulRef}>
        <ul className="description-list">
          {features.map((value, index) => (
            <li key={index} className="description__item">
              <img
                className="description__img"
                src={checkmark}
                alt="checkmark"
              />
              <p className="description__txt">{value}</p>
            </li>
          ))}
        </ul>
        {paidPro && (
          <div className="description__btnBlock">
            <button className="description__firstBtn" onClick={handleClick}>
              {I18n.t("plans.subscribe")}
            </button>
          </div>
        )}
        {paidStandartPlus && (
          <div className="description__btnBlock">
            {/* TODO: добавить когда будет готова реф. программа */}

            {/* <button className="description__secondBtn">
              {I18n.t("plans.getFree")}
            </button> */}
            <button className="description__firstBtn" onClick={handleClick}>
              {I18n.t("plans.pay")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Description;
